var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSocial3Dots(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.08282 7.125C10.8844 7.125 13.1656 9.30551 13.1656 11.998C13.1656 14.6904 10.8944 16.8709 8.08282 16.8709C5.27126 16.8709 3 14.6904 3 11.998C3 9.30551 5.27126 7.125 8.08282 7.125ZM16.1873 7.40941C17.5881 7.40941 18.7287 9.46668 18.7287 11.998C18.7287 14.5293 17.5881 16.5865 16.1873 16.5865C14.7865 16.5865 13.6459 14.5293 13.6459 11.998C13.6459 9.46668 14.7865 7.40941 16.1873 7.40941ZM20.1095 7.88344C20.5998 7.88344 21 9.72265 21 11.998C21 14.2733 20.5998 16.1125 20.1095 16.1125C19.6192 16.1125 19.219 14.2733 19.219 11.998C19.219 9.72265 19.6192 7.88344 20.1095 7.88344Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSocial3Dots);
export default __webpack_public_path__ + "static/media/icon-social-3-dots.d1251d8b4f662a328237a3e15eafbc29.svg";
export { ForwardRef as ReactComponent };